import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/** Bump for each release. Used by footer + Settings → System Information (import this constant). */
export const APP_VERSION = '5.0';

/** Reserve this much space at the bottom of scrollable areas when the footer is fixed */
export const APP_FOOTER_RESERVE_PX = 88;

const DRAWER_EXPANDED = 256;
const DRAWER_COLLAPSED = 64;

/**
 * @param {{ variant?: 'app' | 'dark'; insetLeft?: number; fixed?: boolean }} props
 * - fixed: pin to viewport bottom (always visible). insetLeft: clear the sidebar strip (px).
 */
export default function AppFooter({ variant = 'app', insetLeft = 0, fixed = true }) {
  const theme = useTheme();
  const year = new Date().getFullYear();
  const isDark = variant === 'dark';

  return (
    <Box
      component="footer"
      data-workwise-footer
      data-footer-revision="unified-line-20260411"
      sx={{
        flexShrink: 0,
        width: '100%',
        boxSizing: 'border-box',
        py: 1.75,
        px: { xs: 2, sm: 2.5 },
        borderTop: isDark ? '1px solid rgba(148, 163, 184, 0.25)' : `1px solid ${theme.palette.divider}`,
        backgroundColor: isDark ? '#0f172a' : theme.palette.background.paper,
        ...(fixed
          ? {
              position: 'fixed',
              bottom: 0,
              left: insetLeft,
              right: 0,
              zIndex: theme.zIndex.appBar,
              boxShadow: isDark
                ? '0 -6px 24px rgba(0,0,0,0.45)'
                : '0 -4px 18px rgba(15, 23, 42, 0.1)',
            }
          : {}),
      }}
    >
      <Typography
        variant="caption"
        component="div"
        sx={{
          width: '100%',
          maxWidth: '1280px',
          margin: '0 auto',
          textAlign: 'center',
          fontWeight: 500,
          lineHeight: 1.5,
          color: isDark ? '#cbd5e1' : 'text.secondary',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          paddingInline: 0.5,
        }}
      >
        © {year}{' '}
        <Link
          href="https://workwisesoft.com/"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
          sx={{ fontWeight: 700 }}
        >
          WorkWiseSoft
        </Link>{' '}
        · v{APP_VERSION} · Work & logistics by{' '}
        <Link
          href="https://canmakeit.eu/"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
          sx={{ fontWeight: 700 }}
        >
          Can Make It
        </Link>
      </Typography>
    </Box>
  );
}

export { DRAWER_EXPANDED, DRAWER_COLLAPSED };
